import { buildConfig } from './configBuilder';

// Build config from minimal config injected in HTML
// Full URL construction happens here in compiled JS, not in plain HTML
const config = buildConfig(globalThis.__minimalConfig__ || {});

// Also set on window for legacy access
globalThis.config = config;

export default config;
